import { Layer, LayerProps, Source, SourceProps } from "react-map-gl";

export interface BaseLayerProps {
  layer: LayerProps;
  source: SourceProps;
}
export const BaseLayer = (props: BaseLayerProps) => {
  const { source, layer } = props;
  return (
    <Source {...source}>
      <Layer {...layer} />
    </Source>
  );
};
